import SEO from '../components/SEO';
import DeveloperToolsPanel from '../components/DeveloperToolsPanel';

export default function JSONFormatterPage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "JSON Formatter & Minifier",
    "applicationCategory": "DeveloperApplication",
    "operatingSystem": "Web",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
    "description": "Free online JSON formatter and minifier. Format, beautify, and validate JSON data instantly."
  };

  return (
    <>
      <SEO
        title="JSON Formatter & Minifier - Format and Beautify JSON Online | JsonToonCraft"
        description="Free JSON formatter and minifier tool. Format, beautify, validate and minify JSON data instantly. Works offline with no data collection. Fast and secure."
        keywords="JSON formatter, JSON beautifier, JSON minifier, JSON validator, format JSON online, beautify JSON, minify JSON"
        canonicalUrl="https://jsontooncraft.com/dev-tools/json-formatter"
        structuredData={structuredData}
      />

      <DeveloperToolsPanel initialTool="json" />
    </>
  );
}
